module.exports = {"name":"verifiedSkillsPilot","parameters":[{"name":"orgIds","value":[]},{"name":"vspEnabled","valid":[false,true],"value":false}]}